import React from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import { StatusManager } from 'common/components/StatusManager';
import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { StyledDivider } from 'features/daily-plan/components/shared/TaskDetailsDrawer/TaskDetailsDrawer.styled';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

import { ROLEPLAY_FEEDBACK_STATUSES } from '../constants';

import { useStyles } from './RoleplayCallTranscript.styled';

const COPIES = strings.ai.generators.roleplay.feedbackDrawer.tabs.transcript;

export const RoleplayCallTranscript = ({ callId }) => {
  const classes = useStyles();
  const { refreshData, state } = useFetchWithStatusV2({
    apiInstance: SECONDARY_API_CLIENT,
    endpoint: `${AI_ENDPOINTS.roleplayCallTranscript.replace(':id', callId)}`
  });

  const data = state?.results || {};
  const isCompleted = data?.status?.id === ROLEPLAY_FEEDBACK_STATUSES.completed;
  const transcripts = data?.transcripts || [];

  return (
    <StatusManager
      status={state.status}
      slots={{
        Error: <EmptyPlaceholder title={COPIES.error} subtitle={state.error} />,
        Loading: (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        )
      }}
    >
      {isCompleted ? (
        <div className={classes.contentContainer}>
          <div className={classes.headerSection}>
            <Typography variant="subtitle1">{COPIES.title}</Typography>

            <Typography variant="body2">{data?.summary || COPIES.noTranscript}</Typography>
          </div>

          <StyledDivider />

          {transcripts.length > 0 && (
            <div className={classes.transcriptsContainer}>
              {transcripts.map(transcript =>
                transcript?.id ? (
                  <div className={classes.transcriptRow} key={transcript?.id}>
                    {transcript?.time && (
                      <Typography color="textSecondary" variant="caption">
                        {transcript.time}
                      </Typography>
                    )}
                    <Typography variant="body2">
                      <b>{transcript?.speakerName}: </b>
                      {transcript?.text}
                    </Typography>
                  </div>
                ) : null
              )}
            </div>
          )}

          <div className={classes.callEndedContainer}>
            <Typography color="textSecondary" variant="body2">
              {COPIES.callEnded}
            </Typography>
          </div>
        </div>
      ) : (
        <EmptyPlaceholder title={COPIES.emptyState.title} subtitle={COPIES.emptyState.subtitle}>
          <Button color="primary" onClick={refreshData} startIcon={<RefreshOutlinedIcon />}>
            {COPIES.emptyState.actionButton}
          </Button>
        </EmptyPlaceholder>
      )}
    </StatusManager>
  );
};
